<script lang="ts">
  import { onMount } from "svelte";
  import SearchHeader from "../../components/SearchHeader.svelte";
  import { Table } from "../../components/Table";
  import MainLayout from "../../layout/MainLayout.svelte";
  import { filter, loading, records, pagination, initList, onCreate, onEdit, onDelete, onPageChange, search } from "./transport-document.store";
  import { transportDocumentDtoFields } from "../../utils/TableFields/transport-document-dto.fields";
  import PhaseCodeDropdown from "../../components/Business/PhaseCodeDropdown.svelte";
  import Input from "../../components/Form/Fields/Input.svelte";

  onMount(initList);
</script>

<MainLayout>
  <SearchHeader
    entitySingular="DDT"
    entityPlural="DDT"
    numRecords={$pagination != null ? $pagination.totalRecords : 0}
    bind:searchValue={$filter.criteria.query}
    on:search={(e) => search()}
  >
    <div slot="search" class="level-item weight-label-search-box">
      <div style="margin-right:0.5rem;min-width: 5rem;">
        <Input name="" required={false} placeholder="lotto" bind:value={$filter.criteria.lotNumber} />
      </div>
      <div style="min-width: 5rem;">
        <PhaseCodeDropdown name="" required={true} bind:value={$filter.criteria.phaseCodeId} on:select={(e) => search(e.detail)} />
      </div>
    </div>
  </SearchHeader>

  <Table
    loading={$loading}
    fields={transportDocumentDtoFields}
    records={$records}
    pagination={$pagination}
    createEnabled={true}
    editEnabled={true}
    deleteEnabled={true}
    on:create={(_) => onCreate()}
    on:edit={(e) => onEdit(e.detail)}
    on:delete={(e) => onDelete(e.detail)}
    on:pageChange={(e) => onPageChange(e.detail)}
  />
</MainLayout>
